import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useFetch } from '../hook/useFecth';
import useErrors from '../hook/useErrors';
import server from '../services/server';
import AddressInput from './AddressInput';
import PhoneInputMasked from './masks/PhoneInputMasked';
import { Navigate, useNavigate } from 'react-router-dom';

const validationSchema = Yup.object().shape({
    email: Yup.string().email('Email inválido').required('Email é obrigatório'),
    password: Yup.string().nullable().optional(),
    repeatPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'As senhas não coincidem')
});

function ViewProfileLayer({ data, mutate, backTo = '/usuarios' }) {
    const { setErrors, toast } = useErrors();
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const navigate = useNavigate();

    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, handleBlur, setFieldValue, touched, values, setValues, resetForm } =
        useFormik({
            initialValues: {
                nome: '',
                status: '',
                email: '',
                funcao: 'ADMIN',
                senha: '',
                repeatPassword: '',
                action: 'create'
            },
            validationSchema: validationSchema,
            validateOnMount: true,
            validateOnChange: true,
            onSubmit: async (values, { setSubmitting, resetForm }) => {
                try {
                    if(values.action ==='update') {
                        console.log(data?.id)
                        await server.put(`usuario/${values.id}`, values);
                        mutate();
                        toast.success('Perfil alterado com sucesso!');
                        setSubmitting(false);
                    }
                    if(values.action === 'create') {
                        console.log("create")
                        await server.post(`usuario`, values);
                      
                        toast.success('Perfil alterado com sucesso!');
                        setSubmitting(false);
                    }
                  
                } catch (error) {
                    setSubmitting(false);
                    console.log(error);
                    setErrors(error);
                }
            },
        });

    useEffect(() => {
        if (Boolean(data)) {
            setValues({ ...values, ...data, action: 'update' }, true);
        }
    }, [data]);

    function handleCheckboxChange(e) {
        setFieldValue('status', e.target.checked);
    };

    const typeMethodOptions = [
        { value: '', label: 'Selecione o funcao do usuário', disabled: true },
        { value: 'ADMIN', label: 'Administrador' },
        { value: 'FUNCIONARIO', label: 'Funcionário' },
    ];

    // Toggle function for password field
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    // Toggle function for confirm password field
    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };

    console.log('data', data)
    return (
        <div className='card'>
            <div className='card-body'>

                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">

                            <label htmlFor="nome" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                Nome completo
                                <span className="text-danger-600">*</span>{' '}
                                {touched.nome && errors.nome && <span classnome="text-danger-600">{errors.nome}</span>}
                            </label>
                            <input type="text" className="form-control radius-8" id="nome" placeholder="Nome Completo" {...getFieldProps('nome')} />
                        </div>

                        <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                            <label htmlFor="nome" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                E-mail
                                <span className="text-danger-600">*</span>{' '}
                                {touched.email && errors.email && <span classname="text-danger-600">{errors.email}</span>}
                            </label>
                            <input type="text" className="form-control radius-8" id="email" placeholder="E-mail válido do usuário" {...getFieldProps('email')} />
                        </div>  
                        

                        {/* <div className="mb-20 col-xxl-3 col-xl-4 col-md-6 col-sm-12">
                            <label htmlFor="payment_entry" className="form-label text-neutral-900">
                                funcao usuário
                            </label>
                            <select
                                id="funcao"
                                className={`form-control radius-8 ${touched.funcao && errors.funcao ? 'is-invalid' : ''
                                    }`}
                                {...getFieldProps('funcao')}
                            >
                                {typeMethodOptions.map((option, idx) => (
                                    <option key={idx} value={option.value} disabled={option.disabled || false}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div> */}

                        <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">

                            <label htmlFor="your-password" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                Nova senha <span className="text-danger-600">*</span>
                            </label>
                            <div className="position-relative">
                                <input
                                    type={passwordVisible ? 'text' : 'password'}
                                    className={`form-control radius-8 ${touched.password && errors.password ? 'is-invalid' : ''}`}
                                    id="your-password"
                                    placeholder={`${data?.id ? 'Digite a nova senha*' : 'Digite a senha*'}`}
                                    {...getFieldProps('senha')}
                                />
                                <span
                                    className={`toggle-password ${passwordVisible ? 'ri-eye-off-line' : 'ri-eye-line'
                                        } cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                    onClick={togglePasswordVisibility}
                                ></span>
                            </div>
                            {touched.password && errors.password ? <div className="text-danger">{errors.password}</div> : <></>}
                        </div>

                        {values?.password && (
                            <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">

                                <label htmlFor="confirm-password" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Confirmar nova senha <span className="text-danger-600">*</span>
                                </label>
                                <div className="position-relative">
                                    <input
                                        type={confirmPasswordVisible ? 'text' : 'password'}
                                        className={`form-control radius-8 ${touched.repeatPassword && errors.repeatPassword ? 'is-invalid' : ''}`}
                                        id="confirm-password"
                                        placeholder="Confirme a senha*"
                                        required
                                        {...getFieldProps('repeatPassword')}
                                    />
                                    {touched.repeatPassword && errors.repeatPassword ? <div className="text-danger">{errors.repeatPassword}</div> : <></>}
                                    <span
                                        className={`toggle-password ${confirmPasswordVisible ? 'ri-eye-off-line' : 'ri-eye-line'
                                            } cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                        onClick={toggleConfirmPasswordVisibility}
                                    ></span>
                                </div>
                            </div>
                        )}



                    </div>
                    <footer className="d-flex card-footer bg-white align-items-cent justify-content-end gap-3 mt-10">
                        <div className="form-switch  switch-primary   d-flex align-items-center gap-3">

                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="switch2"
                                defaultChecked={false}
                                checked={values.status}

                                onClick={handleCheckboxChange}
                                {...getFieldProps('status')}

                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="switch2"
                            >
                                Status
                            </label>
                        </div>
                        <button
                            type="button"
                            className="btn btn-primary border border-primary-600 text-sm px-24 py-8 radius-8"
                            onClick={() => navigate(backTo)}
                        >
                            Voltar
                        </button>
                        <button
                            type="submit"
                            className="btn btn-success border border-success text-sm px-24 py-8 radius-8"
                            disabled={isSubmitting || !isValid}
                        >
                            {isSubmitting ? 'Salvando...' : 'Salvar'}
                        </button>
                    </footer>
                </form>
            </div>
        </div >
    );
}

export default ViewProfileLayer;
